export const engagementLocationsApps = "/engagement/locations_apps";
